interface TooltipRow {
  key: string;
  label: string;
  value: string;
  color?: string;
}

interface ChartTooltipProps {
  title: string;
  /** Secondary line under the title — the full text of a truncated axis label. */
  note?: string;
  rows: TooltipRow[];
}

export function ChartTooltip({ title, note, rows }: ChartTooltipProps) {
  return (
    <div className="chart-tooltip">
      <div className="chart-tooltip__title">{title}</div>
      {note && <div className="chart-tooltip__note">{note}</div>}
      {rows.map((row) => (
        <div className="chart-tooltip__row" key={row.key}>
          <span className="chart-tooltip__key">
            {row.color && <span className="chart-tooltip__swatch" style={{ background: row.color }} />}
            {row.label}
          </span>
          <span className="chart-tooltip__value">{row.value}</span>
        </div>
      ))}
    </div>
  );
}
